module.exports = __webpack_public_path__ + "static/media/na.6d5424be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/na.png
// module id = 1938
// module chunks = 0